var _defs, _polygon, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacelecicon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bfbfbf;fill-rule:evenodd;}.cls-2{fill:url(#AES_Gradient_3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AES_Gradient_3",
    x1: 115.21,
    y1: 265.21,
    x2: 233.47,
    y2: 265.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3250fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#9e70ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#2aceeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cbf38"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AES_Icons-Talent-RGB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "175 46.73 207.3 112.18 279.53 122.68 227.26 173.62 239.6 245.56 175 211.6 110.4 245.56 122.73 173.62 70.47 122.68 142.7 112.18 175 46.73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.47,260.33l-5.73,16.88-52.9-30.1-53.93,28.41-5.7-16.78,60-31.58Zm-58.28-2.25-51.11,26.77,5.69,16.77,45-23.59,44.08,25.24,5.74-16.89Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacelecicon2);
export default __webpack_public_path__ + "static/media/facelecicon2.c1f7cb156db3b8b19cf2d4b832ef487b.svg";
export { ForwardRef as ReactComponent };